"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _index2 = _interopRequireDefault(require("@/components/echartsNew/index"));

var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));

var _statistic = require("@/api/statistic");

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 权限判断函数
var _default = {
  components: {
    echartsNew: _index2.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 24,
        xs: 24
      },
      options: this.$timeOptions,
      name: "近30天",
      timeVal: [],
      fromList: this.$constants.timeList,
      dateLimit: "",
      dateLimitPram: {},
      list: [],
      optionData: {},
      style: {
        height: "400px"
      },
      pickerOptions: this.$timeOptions //快捷时间选项

    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)));
    this.timeVal = [start, end];
  },
  mounted: function mounted() {
    this.dateLimit = "lately7";
    this.dateLimitPram = "lately7";
    this.getStatistics();
    this.getTrend();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.dateLimit = e ? this.timeVal.join(",") : "";
      this.dateLimitPram = e ? this.timeVal.join(",") : "";
    },
    selectChange: function selectChange(limit) {
      if (limit == "") {
        //昨天的时间
        var day1 = new Date();
        var day2 = new Date();
        day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
        day2.setTime(day2.getTime() - 24 * 60 * 60 * 1000);
        var s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
        var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
        this.dateLimitPram = "".concat(s1, ",").concat(s2);
        this.getTrend();
        this.getStatistics();
      } else {
        this.dateLimitPram = limit;
        this.getTrend();
        this.getStatistics();
      }
    },
    onSeach: function onSeach() {
      this.getStatistics();
      this.getTrend();
    },
    exports: function () {
      var _exports = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
        var th, filekey, data, fileName, lebData;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                th = [], filekey = [], data = [], fileName = "";
                _context.next = 3;
                return this.getExcelData();

              case 3:
                lebData = _context.sent;
                //表格主要数据
                if (!fileName) fileName = "商品统计表"; //文件名

                if (!filekey.length) {
                  filekey = lebData.filekey;
                }

                if (!th.length) th = lebData.header; //表头

                data = data.concat(lebData.exportData);
                (0, _newToExcel.default)(th, filekey, fileName, data);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exports() {
        return _exports.apply(this, arguments);
      }

      return exports;
    }(),
    getExcelData: function getExcelData(excelData) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        (0, _statistic.productTrendApi)({
          dateLimit: _this.dateLimitPram
        }).then(function (res) {
          var header = ["日期/时间", "浏览量", "新增商品数量", "收藏量", "加购件数", "下单商品数", "交易成功商品数"]; //表头

          var filekey = ["date", "pageView", "addProductNum", "collectNum", "addCartNum", "orderProductNum", "orderSuccessProductNum"]; //表头每一项对应的key

          var exportData = new Array();
          exportData = res.map(function (item) {
            return {
              date: item.date,
              pageView: item.pageView,
              addProductNum: item.addProductNum,
              collectNum: item.collectNum,
              addCartNum: item.addCartNum,
              orderProductNum: item.orderProductNum,
              orderSuccessProductNum: item.orderSuccessProductNum
            };
          });
          resolve({
            header: header,
            filekey: filekey,
            exportData: exportData
          });
        });
      });
    },
    // 统计
    getStatistics: function getStatistics() {
      var _this2 = this;

      (0, _statistic.productDataApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var list = [{
          name: "新增量",
          icon: "iconxinzengliang",
          color: "#1890FF",
          class: "one",
          info: "在选定条件下，新增加的商品之和",
          list: {
            num: res.newProductNum,
            percent: res.newProductNumRatio
          }
        }, {
          name: "浏览量",
          icon: "iconliulanliang",
          color: "#A277FF",
          class: "two",
          info: "在选定条件下，所有商品详情页被访问的次数，一个人在统计时间内访问多次记为多次",
          list: {
            num: res.pageView,
            percent: res.pageViewRatio
          }
        }, {
          name: "收藏量",
          icon: "iconshoucangliang",
          color: "#EF9C20",
          class: "three",
          info: "在选定条件下，被收藏的商品数量之和",
          list: {
            num: res.collectNum,
            percent: res.collectNumRatio
          }
        }, {
          name: "加购量",
          icon: "iconjiagouliang",
          color: "#1BBE6B",
          class: "four",
          info: "在选定条件下，添加商品进入购物车的商品件数",
          list: {
            num: res.addCartNum,
            percent: res.addCartNumRatio
          }
        }, {
          name: "交易总件数",
          icon: "iconjiaoyijianshu",
          color: "#4BCAD5",
          class: "five",
          info: "在选定条件下，成功下单的商品件数之和",
          list: {
            num: res.orderProductNum,
            percent: res.orderProductNumRatio
          }
        }, {
          name: "交易成功数",
          icon: "iconjiaoyichenggongshu",
          color: "#EF9C20",
          class: "six",
          info: "在选定条件下，交易成功的商品件数之和",
          list: {
            num: res.orderSuccessProductNum,
            percent: res.orderSuccessProductNumRatio
          }
        }];
        _this2.list = list.map(function (item) {
          return {
            name: item.name,
            icon: item.icon,
            list: item.list,
            info: item.info,
            color: item.color,
            class: item.class,
            ratio: item.list.percent.replace("%", "") / 100
          };
        });
      });
    },
    getTrend: function getTrend() {
      var _this3 = this;

      (0, _statistic.productTrendApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var xAxis = new Array();
        var series = [{
          name: "商品浏览量",
          data: [],
          type: "line",
          smooth: "true",
          yAxisIndex: 0
        }, {
          name: "收藏数量",
          data: [],
          type: "line",
          smooth: "true",
          yAxisIndex: 0
        }, {
          name: "交易总件数",
          data: [],
          type: "line",
          smooth: "true",
          yAxisIndex: 0
        }];
        xAxis = res.map(function (item) {
          return item.date;
        });
        series[0].data = res.map(function (item) {
          return item.pageView;
        });
        series[1].data = res.map(function (item) {
          return item.collectNum;
        });
        series[2].data = res.map(function (item) {
          return item.orderSuccessProductNum;
        });
        _this3.spinShow = true;
        var legend = series.map(function (item) {
          return item.name;
        });
        var col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
        series.map(function (item, index) {
          item.itemStyle = {
            normal: {
              color: col[index]
            }
          };
        });
        _this3.optionData = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985"
              }
            }
          },
          legend: {
            x: "center",
            data: legend
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: "#000000"
              }
            },
            data: xAxis
          },
          yAxis: [{
            type: "value",
            name: "数量",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#7F8B9C"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#F5F7F9"
              }
            }
          }],
          series: series
        };
        _this3.spinShow = false;
      });
    }
  }
};
exports.default = _default;